"use client";
import { motion } from "framer-motion";
import Image from "next/image";
import React from "react";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";

type HeroSectionProps = {
  scrollTargetRef: React.RefObject<HTMLDivElement | null>;
};

const HeroSection: React.FC<HeroSectionProps> = () => {
  // const HeroSection: React.FC<HeroSectionProps> = ({ scrollTargetRef }) => {
  const t = useTranslations("HomePage");
  const router = useRouter();

  // const scrollToBottom = () => {
  //   scrollTargetRef?.current?.scrollIntoView({ behavior: "smooth" });
  // };
  return (
    <div className="relative h-screen">
      <Image
        src={"/samples/skyscrapers.png"}
        alt="Hero Section"
        fill
        className="object-cover object-center"
        priority
        style={{ filter: "brightness(0.4)" }}
      />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="absolute top-1/3 transform -translate-x-1/2 -translate-y-1/2 w-full text-center"
      >
        <div className="max-w-4xl mx-auto px-16 sm:px-12">
          <h1 className="text-5xl font-bold text-white mb-4">
            {t("hero.title")}
          </h1>
          <p className="text-xl text-white mb-8">{t("hero.subtitle")}</p>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
            className="flex flex-col sm:flex-row gap-6 justify-center items-center my-20"
          >
            {/* Primary Button - Search */}
            <motion.button
              onClick={() => router.push("/search")}
              whileTap={{ backgroundColor: "rgba(0, 0, 0, 1.0)" }}
              className="group relative px-8 py-4 bg-black/40 backdrop-blur-sm text-white font-semibold rounded-full border border-white/20 shadow-2xl transition-all duration-300 hover:border-white/40 min-w-[200px]"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-white/10 to-blue-500/10 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="relative flex items-center justify-center gap-3">
                <span className="">{t("hero.search")}</span>
              </div>
            </motion.button>

            {/* Secondary Button - Learn More */}
            <motion.button
              onClick={() => router.push("/user/home")}
              whileHover={{
                backgroundColor: "rgba(0, 0, 0, 0.6)",
              }}
              whileTap={{ backgroundColor: "rgba(0, 0, 0, 1.0)" }}
              className="group relative px-8 py-4 bg-black/40 backdrop-blur-sm text-white font-semibold rounded-full border border-white/20 shadow-2xl transition-all duration-300 hover:border-white/40 min-w-[200px]"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-white/10 to-blue-500/10 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="relative flex items-center justify-center gap-3">
                <span className="">{t("hero.LearnMore")}</span>
              </div>
            </motion.button>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default HeroSection;
